import { db } from '../db/indexeddb';
import { shouldMakeAPICall } from '../utils/network';
import axios from 'axios';
import { API_ENDPOINT } from '../../services/api/resources';

const CACHE_KEY_BUYER_USERS = (t) => `chat_buyer_users_${t}`;

/**
 * Chat Repository (offline)
 * Caches buyer_users (with chat) for Chat page. Use when offline.
 * Online: keep using get_chat_messages / all_user_list as today.
 */
export class ChatRepository {
  async getBuyerUsersFromCache(buyerToken) {
    try {
      const entry = await db.cache.get(CACHE_KEY_BUYER_USERS(buyerToken));
      const list = entry?.value?.buyer_users ?? entry?.value;
      return Array.isArray(list) ? list : [];
    } catch (e) {
      console.warn('ChatRepository.getBuyerUsersFromCache error:', e);
      return [];
    }
  }

  async saveBuyerUsersToCache(buyerToken, data) {
    try {
      const buyer_users = Array.isArray(data?.buyer_users) ? data.buyer_users : (Array.isArray(data) ? data : []);
      await db.cache.put({
        key: CACHE_KEY_BUYER_USERS(buyerToken),
        value: { buyer_users, ...(data && typeof data === 'object' && !Array.isArray(data) ? data : {}) },
        lastSynced: Date.now(),
      });
      console.log(`✅ Cached ${buyer_users.length} buyer_users (with chat) for Chat offline`);
    } catch (e) {
      console.error('ChatRepository.saveBuyerUsersToCache error:', e);
    }
  }

  /**
   * Sync buyer_users (with chat) from API. Call when online so we have data for offline.
   * Uses get_chat_buyers. Response: { buyer_users, total_count?, page_count? }.
   */
  async syncBuyerUsersFromAPI(authToken, buyerToken, userToken, accessType) {
    if (!shouldMakeAPICall(authToken, buyerToken)) {
      return this.getBuyerUsersFromCache(buyerToken);
    }
    try {
      const res = await axios.post(
        API_ENDPOINT.get_chat_buyers,
        {
          buyer_token: buyerToken,
          user_token: userToken,
          access_type: accessType,
        },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      const data = res?.data || {};
      await this.saveBuyerUsersToCache(buyerToken, data);
      return this.getBuyerUsersFromCache(buyerToken);
    } catch (e) {
      console.warn('ChatRepository.syncBuyerUsersFromAPI error:', e?.response?.data || e.message);
      return this.getBuyerUsersFromCache(buyerToken);
    }
  }
}

export const chatRepository = new ChatRepository();
